"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW = exports.TAG = exports.STEP_TEMPLATE = exports.STEP = exports.FLOW = exports.DEPLOYMENT = exports.CARD = exports.BOT = void 0;
const BOT = 'BOT';
exports.BOT = BOT;
const CARD = 'CARD';
exports.CARD = CARD;
const DEPLOYMENT = 'DEPLOYMENT';
exports.DEPLOYMENT = DEPLOYMENT;
const FLOW = 'FLOW';
exports.FLOW = FLOW;
const STEP = 'step';
exports.STEP = STEP;
const STEP_TEMPLATE = 'STEP_TEMPLATE';
exports.STEP_TEMPLATE = STEP_TEMPLATE;
const TAG = 'TAG';
exports.TAG = TAG;
const VIEW = 'VIEW';
exports.VIEW = VIEW;